module.exports = __webpack_public_path__ + "img/green-square.97279e20.svg";